import React, {Component} from 'react';
import classnames from 'classnames';

export default class Label extends Component {
    getTitle(props = this.props) {
        if (this.props.labelData === null || this.props.labelData === undefined || this.props.labelData === '') {
            return null;
        }
        return (
            <p id={props.labelId} className={props.labelClass} style={props.style}>
                {props.labelData}
            </p>
        );
    }

    getIcon(hasIcon) {
        if (!hasIcon) {
            return null;
        }
        return <span className='st-form__icon' />;
    }

    getLabelClasses(props = this.props) {
        const {mandatory, hasError, small, labelClass} = props;
        const className = `react-label ${this.getTitle() ? '' : labelClass}`;
        const classesMap = {
            small,
            mandatory,
            error: hasError
        };
        if (!className) {
            classesMap[className] = true;
        }
        classesMap[className] = true;
        return classnames(classesMap);
    }

    render() {
        const {id = '', children, hasIcon, clickEvent, parentClass, style} = this.props;
        const labelClasses = this.getLabelClasses(this.props);
        return (
            <div id={id} className={`${labelClasses} ${parentClass}`} onClick={clickEvent} style={style}>
                {this.getTitle()}
                {children}
                {this.getIcon(hasIcon)}
            </div>
        );
    }
}
